// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_users__\\+oqbR {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.style_current__BNbpn {
  width: 100%;
  display: flex;
  padding: 15px 20px;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
}
.style_current__part__J\\+9uz {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgb(255, 255, 255);
}
.style_current__part__J\\+9uz .style_coins__LJu-O {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
}
.style_current__icon__0g-Ab {
  width: 26px;
  height: 26px;
  border: 2px solid rgb(255, 199, 1);
  position: relative;
  border-radius: 100px;
  background: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
}
.style_current__icon__0g-Ab p {
  font-size: 1.3rem;
  color: rgb(213, 212, 220);
}
.style_current__title__23vX8 {
  color: rgb(255, 255, 255);
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.style_list__j2idr {
  border-radius: 20px;
  padding: 8px;
}

.style_list__current__BOW2K {
  width: 100%;
  display: flex;
  padding: 7px 10px;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
}

.style_user__Odcjj {
  width: 100%;
  display: flex;
  padding: 7px 10px;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
}
.style_user__Odcjj .style_coins__LJu-O {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
}
.style_user__title__3R9Yw {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: rgb(27, 27, 27);
}
.style_user__part__1fjX8 {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgb(27, 27, 27);
}`, "",{"version":3,"sources":["webpack://./src/features/clans/clan/components/leaderboard/leaderboard-users/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAAF;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBCdI;ADeR;AAAI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAEN;AACE;EACE,WAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,oBAAA;EACA,8BC5BI;ED6BJ,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EACE,iBAAA;EACA,yBClCO;ADmCb;AAEE;EACE,yBCvCI;EDwCJ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,YAAA;AADF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAAF;AACE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AACE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBCrFU;ADsFd;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,sBC3FU;AD4Fd","sourcesContent":["@import 'public/assets/colors';\n\n.users {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.current {\n  width: 100%;\n  display: flex;\n  padding: 15px 20px;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 16px;\n  &__part {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: $white;\n    .coins {\n      font-size: 16px;\n      font-weight: 700;\n      line-height: 24px;\n      text-align: center;\n    }\n  }\n  &__icon {\n    width: 26px;\n    height: 26px;\n    border: 2px solid $yellow;\n    position: relative;\n    border-radius: 100px;\n    background: $white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    p {\n      font-size: 1.3rem;\n      color: $light-grey;\n    }\n  }\n  &__title {\n    color: $white;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: left;\n    max-width: 150px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.list {\n  border-radius: 20px;\n  padding: 8px;\n}\n.list__current {\n  width: 100%;\n  display: flex;\n  padding: 7px 10px;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 12px;\n}\n\n.user {\n  width: 100%;\n  display: flex;\n  padding: 7px 10px;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 12px;\n  .coins {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 24px;\n    text-align: center;\n  }\n  &__title {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: left;\n    color: $black-extra;\n  }\n  &__part {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: $black-extra;\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"users": `style_users__+oqbR`,
	"current": `style_current__BNbpn`,
	"current__part": `style_current__part__J+9uz`,
	"coins": `style_coins__LJu-O`,
	"current__icon": `style_current__icon__0g-Ab`,
	"current__title": `style_current__title__23vX8`,
	"list": `style_list__j2idr`,
	"list__current": `style_list__current__BOW2K`,
	"user": `style_user__Odcjj`,
	"user__title": `style_user__title__3R9Yw`,
	"user__part": `style_user__part__1fjX8`
};
export default ___CSS_LOADER_EXPORT___;
